import './Bookmarks.scss';
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import AuthContext from "../../context/AuthContext";
import SnackbarContext from "../../context/SnackbarContext";
import { API_BASE_URL } from '../../config';
import { authHeaders } from '../../utils/api';

function absoluteUrl(path) {
    if (!path) return '';
    if (/^https?:/i.test(path)) return path;
    return `${API_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
}

export default function Bookmarks() {
    const { authTokens } = useContext(AuthContext);
    const { setSnackbar } = useContext(SnackbarContext);
    const navigate = useNavigate();

    const [bookmarks, setBookmarks] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const r = await fetch(`${API_BASE_URL}/api/books/bookmarks/`, {
                    headers: authHeaders(authTokens),
                });
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                const data = await r.json();
                if (!cancelled) setBookmarks(data.bookmarks ?? []);
            } catch {
                if (!cancelled) setSnackbar({ content: 'تعذر تحميل العلامات', success: false });
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [authTokens, setSnackbar]);

    const removeBookmark = async (id) => {
        try {
            await fetch(`${API_BASE_URL}/api/books/bookmarks/?id=${id}`, {
                method: 'DELETE',
                headers: authHeaders(authTokens),
            });
            setBookmarks(bs => bs.filter(b => b.id !== id));
        } catch {
            setSnackbar({ content: 'تعذر حذف العلامة', success: false });
        }
    };

    return (
        <>
        <Navbar />
        <main className='bm-page'>
            <div className='bm-container'>
                <h1 className='bm-title'>علاماتي المرجعية</h1>

                {loading ? (
                    <p className='bm-empty'>جارٍ التحميل…</p>
                ) : bookmarks.length === 0 ? (
                    <div className='bm-empty-state'>
                        <p>لا توجد علامات بعد.</p>
                        <Link to='/library' className='bm-cta'>تصفّح المكتبة</Link>
                    </div>
                ) : (
                    <ul className='bm-list'>
                        {bookmarks.map(b => (
                            <li key={b.id} className='bm-item'>
                                <button
                                    className='bm-card'
                                    onClick={() => navigate(`/read/${b.book}`)}
                                >
                                    <div className='bm-thumb'>
                                        {b.book_cover ? (
                                            <img src={absoluteUrl(b.book_cover)} alt={b.book_title} />
                                        ) : (
                                            <span>📖</span>
                                        )}
                                    </div>
                                    <div className='bm-info'>
                                        <h3>{b.book_title}</h3>
                                        <p className='bm-author'>{b.book_display_author}</p>
                                        {b.chapter_title && (
                                            <p className='bm-chapter'>
                                                عند: {b.chapter_title || `الفصل ${(b.chapter_order ?? 0) + 1}`}
                                            </p>
                                        )}
                                        <p className='bm-date'>
                                            {new Date(b.date_created).toLocaleDateString('ar-EG')}
                                        </p>
                                    </div>
                                </button>
                                <button
                                    className='bm-remove'
                                    onClick={() => removeBookmark(b.id)}
                                    aria-label='حذف العلامة'
                                    title='حذف'
                                >
                                    ×
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </main>
        <Footer />
        </>
    );
}
